import * as React from 'react'
import { useState } from 'react'

import GoogleMapReact from 'google-map-react'
import { useRecoilValue } from 'recoil'

import { translate } from '../../../state/locale/selectors/translate'
import { Link } from '../Link'
import Marker from './components/Marker'
import styles from './GoogleMaps.module.scss'
import { mapStyles } from './GoogleMaps.styles'
import { IGoogleMapsProps } from './GoogleMaps.types'
import { useMapConsent } from './useMapConsent'

const GOOGLE_PRIVACY_URL = 'https://policies.google.com/privacy'

export const GoogleMaps = ({ locale, map }: IGoogleMapsProps) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
  const i18n = useRecoilValue(translate).maps
  const { grant, granted } = useMapConsent()
  const [remember, setRemember] = useState(false)

  const center = {
    lat: map.centerLat,
    lng: map.centerLng,
  }

  if (!granted) {
    const externalUrl = `https://www.google.com/maps/search/?api=1&query=${center.lat},${center.lng}`

    return (
      <div className={styles.placeholder}>
        <p className={styles.notice}>
          {i18n.notice}&nbsp;
          <Link to={GOOGLE_PRIVACY_URL} blank={true}>
            {i18n.privacyLink}
          </Link>
        </p>
        <button className={styles.loadButton} type={'button'} onClick={() => grant(remember)}>
          {i18n.load}
        </button>
        <label className={styles.remember}>
          <input type={'checkbox'} checked={remember} onChange={() => setRemember(!remember)} />
          {i18n.remember}
        </label>
        <Link className={styles.externalLink} to={externalUrl} blank={true}>
          {i18n.openExternal}
        </Link>
      </div>
    )
  }

  const markerList =
    map?.markers?.map((marker) => <Marker lat={marker.lat} lng={marker.lng} text={marker.title} key={marker.id} />) ||
    null

  return (
    // @ts-ignore
    <GoogleMapReact
      bootstrapURLKeys={{ key: apiKey, language: locale, region: locale }}
      center={center}
      options={{ styles: mapStyles }}
      zoom={map.zoom}
    >
      {markerList}
    </GoogleMapReact>
  )
}
